"use client";

import React from "react";
var __jsx = React.createElement;
import FooterLinks from "../components/links";
import FooterCopyrightMessage from "../components/copyright";
import { useTranslations } from "next-intl";
import { seeClaimsBook } from "@lib/util/link-redirection-ops";
import MaxWidthContainer from "@modules/layout/components/shared/muscle-max-width";
import useTrackEvent from "@lib/hooks/use-track-event";
import { MIXPANEL_EVENTS } from "@lib/mixpanel/mixpanel.event-list";
import FooterConfigButtons from "../../footer-default/components/config-buttons";
import Icons from "@modules/icons";
import FooterLogo from "@modules/shared/logos/footer-logo";
import Image from "next/image";
import demoStoryblokService from "@lib/storyblok/services/demo-service/demo-service";
import { useState } from "react";
import { useEffect } from "react";
import APP_CONFIGURATION from "@lib/app.config";
import useCssModules from "@lib/hooks/use-css-modules";
import { usePathname } from "next/navigation";
const WebFooter = () => {
  var _cssModules$footers$f;
  const t = useTranslations();
  const trackEvent = useTrackEvent();
  const {
    0: footerImage,
    1: setFooterImage
  } = useState('');
  const {
    show_partner_logo
  } = APP_CONFIGURATION.config;
  const pathname = usePathname();
  const {
    cssModules
  } = useCssModules();
  const {
    containerClassNames,
    containerInformationClassNames,
    entityLogoContainerClassNames,
    entityLogoClassNames,
    entityLogoPartnerTextClassNames,
    entityLogoPartnerClassNames,
    linksContainerClassNames,
    privacyPolicyClassNames,
    termsAndConditionsClassNames,
    phoneNumberClassNames,
    phoneNumberIconClassNames,
    emailClassNames,
    emailIconClassNames,
    configButtonsContainerClassNames,
    currencyButtonClassNames,
    currencyButtonIconClassNames,
    languageButtonClassNames,
    languageButtonIconClassNames,
    allRightsReservedClassNames
  } = (_cssModules$footers$f = cssModules === null || cssModules === void 0 ? void 0 : cssModules.footers.footerDefault) !== null && _cssModules$footers$f !== void 0 ? _cssModules$footers$f : {};
  const showConfigsButtons = () => {
    const splitPathname = pathname.split("/");
    if (splitPathname.includes("checkout")) {
      return false;
    }
    return true;
  };
  useEffect(() => {
    const loadFooterImage = async () => {
      const image = await demoStoryblokService.getFooterImage();
      setFooterImage(image);
    };
    loadFooterImage();
  }, []);
  return __jsx(MaxWidthContainer, null, __jsx("div", {
    className: containerInformationClassNames
  }, __jsx("div", null, __jsx("div", {
    className: entityLogoContainerClassNames
  }, __jsx(FooterLogo, {
    className: entityLogoClassNames
  }), show_partner_logo && __jsx("div", {
    className: "flex flex-row flex-wrap items-center gap-4"
  }, __jsx("p", {
    className: entityLogoPartnerTextClassNames
  }, t("Demos.PARTNERED_WITH")), __jsx("div", {
    className: entityLogoPartnerClassNames
  }, footerImage && __jsx(Image, {
    src: footerImage,
    alt: "Partner",
    fill: true,
    className: "object-contain"
  })))), __jsx(FooterLinks, null), __jsx(FooterCopyrightMessage, null)), __jsx("div", {
    className: "flex flex-col items-center gap-4"
  }, showConfigsButtons() && __jsx(FooterConfigButtons, null), process.env.NEXT_PUBLIC_CLAIMS_BOOK_URL ? __jsx("div", {
    className: "flex gap-2 items-center"
  }, __jsx("div", null, __jsx(Icons.book, {
    size: 23,
    color: "#FFFFFF"
  })), __jsx("div", {
    onClick: () => {
      seeClaimsBook();
      trackEvent(MIXPANEL_EVENTS.Home.CLAIMS_OPEN_BOOK);
    },
    className: "cursor-pointer text-sm text-white font-bold"
  }, t("Shared.Layout.CLAIMS_BOOK"))) : null)));
};
export default WebFooter;